<template>
  <span>
      <v-btn
        class="mtfont"    
          v-on:click="modalHandler"
          icon
        >
        <v-icon>edit</v-icon>
      </v-btn>
    <v-dialog
      v-model="editDialog"
      persistent
      max-width="700px"
    >
      <v-card
          tile
          class="mtfont"
      >
    <v-container class="pt-6">
      <v-toolbar dense flat>
        <v-toolbar-title>Add Personal Formula</v-toolbar-title>

        <v-spacer></v-spacer>
        <v-btn
            depressed
            text
            class="mb-3 mr-3"
            v-on:click="editDialog=false"
        >CANCEL</v-btn>
        <v-btn
            depressed
            color="black"
            style="color: #fecb39;"
            class="mb-3 mr-3"
            v-on:click="saveFormula"
        >SAVE</v-btn>
      </v-toolbar>

      <v-card class="mtfont" outlined>
        <v-card-title>
          <span>COLOR</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col
                cols="12"
                sm="2">
              <v-text-field
                  label="Code"
                  v-model="selectedItem.color.code"
                  disabled
              ></v-text-field>
            </v-col>
            <v-col
                cols="12"
                sm="5">
              <!--v-model="selectedItem.color.name" -->
              <v-text-field
                  label="Name"
                  v-model="customName"
                  single-line
              ></v-text-field>
            </v-col>
            <v-col
                cols="12"
                sm="2">
              <v-text-field
                  label="Hex"
                  v-model="selectedItem.color.hex"
                  disabled
              ></v-text-field>
            </v-col>
            <v-col
                cols="12"
                sm="3">
              <v-text-field
                  label="Version"
                  :value="(new Date()).toLocaleDateString()"
                  disabled
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="mtfont mt-4" outlined>
        <v-card-title>
          <span >FORMULA</span>
          <v-spacer></v-spacer>
          <span class="gram-total">TOTAL: {{total}}g</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col style="color:#FECB39">MATERIALS</v-col>
            <v-col style="text-align: right;"><small>*a total of 100g is recommended</small></v-col>
          </v-row>
          <v-row>
            <v-col
                v-for="item in materials"
                :key="item.name"
                cols="12"
                >
              <v-text-field
                  :label="item.name"
                  v-model="formula[item.id]"
                  required
              ></v-text-field>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </v-container>
  </v-card>
    </v-dialog>
  </span>
</template>

<script>
  export default {
    name: 'UserEditFormulaModal',
    props: ['selectedItem'],

    data: () => ({
      editDialog: false,
      dialogMessage: '',
      colors: [],
      color: '',
      materials: [],
      formula: {},
      customName: ''
    }),
    computed: {
      messageColor: function () {
        return ~this.dialogMessage.indexOf('Error')? 'red': 'green'
      },
      total: function () {
        return (Object.keys(this.formula).reduce((total, item) => {
          return (total + +this.formula[item])
        }, 0)).toFixed(2);
      }
    },
    methods: {
      modalHandler() {
        const self = this;
        this.editDialog = true;
        this.$store.dispatch('setCurrentFavorite', this.selectedItem)
          .then(result => {
            self.populateModal(result);
          })
      },
      populateModal(currentFormula) {
        const materials = currentFormula && currentFormula.materials;
        if(!materials || !materials.length) return;

        let startTotal = 0;
        const tempFormula = {};

        materials.forEach(mat => {
          startTotal += mat.amount;
          tempFormula[mat.material.id] = mat.amount;
        });
        this.formula = tempFormula;
      },
      saveFormula() {
        if(!Object.keys(this.formula).length || !Object.keys(this.formula).reduce((total, key)=>{return (total + +this.formula[key]);}, 0)) {
          alert('No Materials Entered!\nEnter missing information and try again.');
          return;
        }

        const materials = Object.keys(this.formula).map(material => {
          if(material && this.formula[material]) {
            return `{material: "${material}", amount: ${+this.formula[material]}}`;
          }
        });

        const updateString = `{
          colorId: "${this.selectedItem.color.id}",
          materials: [${materials}],
          customName: "${this.customName}",
          total: ${this.total}
        }`;

        console.log('NEW_FORMULA', updateString);

        this.$store.dispatch('userFormulaEdit', updateString)
            .then(result => {
              if(result.status === 200) result.json();
              else throw new Error('ERROR! Formula Submission Failed with Server Error ' + result.status);
            })
            .then(data => {
              alert('Success! New Formula Saved.');
              this.editDialog = false;
              location.reload();
            })
            .catch(error => {
              console.error('ERROR', error);
              alert(error);
            });
      },
      setColorFields(event) {
        const selectedColor = this.colors.find(color => color.code === event);

        this.colorCode = event;
        this.colorHex = selectedColor.hex;
        this.colorName = selectedColor.name;
      }
    },
    created() {
      this.$store.dispatch('getAllMaterials')
          .then(results => results.json())
          .then(data => {this.materials = data.data.materials});

      const self = this;
      setTimeout(_=>{
        self.populateModal();
        self.customName = this.selectedItem.customName || this.selectedItem.color.name;
      }, 1000);
    }
  }
</script>

<style scoped>
</style>